import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetPaymentTerms({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/payment_term/list?order_by=name&order_dir=desc", // ?order_by=created_on&order_dir=desc
        params: {
          page: list.page || 0,
          name: list.search ? '*' + list.search + '*' : null,
          per_page: list.total || 10,
          // status: list.is_active ? "active" : '',
          is_active: list.is_active || null,
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetPaymentTermById({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: `/payment_term/${list.id}`,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  AddPaymentTerm({ commit }, payment) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/payment_term/create",
        data: payment.payment,
        method: "POST"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },
  EditPaymentTerm({ commit }, payment) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/payment_term/${payment.id}`,
        data: payment.payment,
        method: "PATCH"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },
  DeletePaymentTerm({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/payment_term/" + id,
        method: "DELETE"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },

};
// mutations
const mutations = {

};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
